export function SessionStorage(key?: string) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return (target: Object, propName: string) => {
        const factKey: string = key || propName;

        function getValue(): string {
            return sessionStorage.getItem(factKey);
        }

        function setValue(val: unknown): void {
            if (val) {
                sessionStorage.setItem(factKey, typeof val === 'string' ? val : JSON.stringify(val));
            } else {
                sessionStorage.removeItem(factKey);
            }
        }

        Object.defineProperty(target, propName, {
            configurable: true,
            enumerable: true,
            get: getValue,
            set: setValue,
        });
    };
}
